import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${themeGet('spacing.2xl')};
`;
